import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux/actions';
import * as tutorialActions from '../../tutorial/redux/actions';
import PageTab from './PageTab';
import CollectionTab from './CollectionTab';
import EventTab from './EventTab';
import SnippetTemplateTab from './SnippetTemplateTab';
import { AssetTab } from '..';
import { categoryOrderMap } from '../../../common/utils/configureEditorCommands';
import SidebarTopNav from './SidebarTopNav';
import { isProjectReadOnly } from '../../home/app_util';

export class SideBar extends Component {
  state = {
    isLayerOpen: false,
  };
  static propTypes = {
    editor: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };

  toggleLayer = () => {
    const container = $('.sidebar');
    container.removeClass('selected');
    this.setState({ isLayerOpen: !this.state.isLayerOpen });
  };

  toggleSidebar = (event, name) => {
    this.setState({ isLayerOpen: false });
    const sideBarToVisible = document.getElementById(name);
    const alreadySelected = sideBarToVisible.classList.contains('selected');
    let i, tabcontent, tablinks;

    tabcontent = document.getElementsByClassName('sidebar');
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].classList.remove('selected');
    }

    tablinks = document.getElementsByClassName('gjs-tablinks');
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(' selected', '');
    }
    if (!alreadySelected) {
      sideBarToVisible.classList.add('selected');
      event.currentTarget.className += ' selected';
    }

    if (name === 'BLOCKS') {
      const blockCategoriesEl = document.querySelector(
        '#BLOCKS > #blocks > div > .gjs-block-categories',
      );
      if (blockCategoriesEl) {
        Array.from(blockCategoriesEl.children).forEach((bc) => {
          const blockCatTitleEl = bc.querySelector('.gjs-title');
          const blockCatTitleElTxt = blockCatTitleEl.textContent.trim();
          if (blockCatTitleElTxt.includes('Sections') || blockCatTitleElTxt.includes('Pre-Built')) {
            bc.remove();
          }

          if (!bc.hasAttribute('style')) {
            bc.style.order = categoryOrderMap[blockCatTitleElTxt];
          }
        });
      }
    }
  };

  filterBlockBySearch = (event) => {
    const { value } = event.target;
    const blocksEl = document.querySelectorAll(
      '#BLOCKS > #blocks > div > .gjs-block-categories .gjs-block',
    );

    if (blocksEl && blocksEl.length > 0) {
      Array.from(blocksEl).forEach((bc) => {
        const blockCategory = bc.closest('.gjs-block-category');
        const blockTitleEl = bc.getAttribute('title');
        if (blockTitleEl) {
          if (blockTitleEl.toLowerCase().includes(value.toLowerCase())) {
            bc.style.display = 'flex';
          } else {
            bc.style.display = 'none';
          }
        }
      });
    }
  };

  render() {
    const { projectId, pageId, version } = this.props;
    const isReadOnly = isProjectReadOnly(projectId);
    return (
      <>
        <div className="mini-sidebar">
          <ul>
            <li title="Layers" className="gjs-tablinks" onClick={this.toggleLayer}>
              <i className="wb webconnect-list-check"></i>
            </li>
          </ul>

          <SidebarTopNav
            projectId={projectId}
            pageId={pageId}
            version={version}
            toggleSidebar={this.toggleSidebar}
            tutorialActions={this.props.tutorialActions}
          />
        </div>
        <div id="LAYERS" className={`sidebar ${this.state.isLayerOpen ? 'layer-selected' : ''}`}>
          <div id="layer-manager" className={`column blocks is-abs--t-l gjs-one-bg blocks-open`} />
        </div>
        <div id="BLOCKS" className="sidebar">
          <div className="form-outline" style={{ padding: '10px' }}>
            <input
              type="search"
              className="form-control form-control-sm"
              placeholder="&#xf55c; Eg: Link, Data Table etc."
              style={{ fontFamily: 'Arial, Webconnect' }}
              onChange={this.filterBlockBySearch}
            />
          </div>
          <div id="blocks" className={`column blocks is-abs--t-l gjs-one-bg blocks-open`}></div>
        </div>
        <div id="PAGES" className="sidebar">
          <PageTab
            projectId={projectId}
            currentPageId={pageId}
            version={version}
            isReadOnly={isReadOnly}
          />
        </div>
        <div id="COLLECTIONS" className="sidebar">
          <CollectionTab projectId={projectId} version={version} isReadOnly={isReadOnly} />
        </div>
        <div id="TEMPLATES" className="sidebar">
          <SnippetTemplateTab
            projectId={projectId}
            currentPageId={pageId}
            version={version}
            isReadOnly={isReadOnly}
          />
        </div>
        <div id="EVENTS" className="sidebar">
          <EventTab projectId={projectId} version={version} isReadOnly={isReadOnly} />
        </div>
        <div id="ASSETS" className="sidebar">
          <AssetTab projectId={projectId} version={version} isReadOnly={isReadOnly} />
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    editor: state.editor,
    tutorial: state.tutorial,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    tutorialActions: bindActionCreators({ ...tutorialActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
